import React, {Fragment} from 'react';
import {Button} from 'material-ui';
import AddIcon from 'material-ui-icons/Add';
import Tooltips from './../Tooltips';

export default ({experiment}) => {
	return (
	<Fragment>
		<div style={{textAlign:'right', position:'absolute', right:'2px', top:'-1px'}}><Tooltips id="leftRail" /></div>
		<ScreenThumbnail screen={experiment.data.screens} experiment={experiment} disableDrag  />

		<div style={{textAlign:'center'}}>
		<Button variant="fab" mini onClick={e => {experiment.openAddScreenDialog(e)}}>
			<AddIcon />
		</Button>
		</div>
	</Fragment>
	);
}

class ScreenThumbnail extends React.Component {

	componentDidMount(){
		this.node._screen = this.props.screen;
		this.node._parent = this.props.parent;
	}

	render(){
		let {screen, experiment, disableDrag, parent} = this.props;
		let {id,  children = []} = screen;
		return (
		<Fragment>
			<DropArea parent={parent} screen={screen} />
			{!!screen.isGroup &&
				<div
				ref={ n => this.node = n }	
				className={`${disableDrag ? '' : 'draggable'} group screen-thumbnail ${experiment.isSelectedScreen(screen) && 'selected'}`}
				onClick={(e) => { if(experiment.skipClick){return;} e.stopPropagation(); experiment.selectScreen(screen, e.metaKey || e.ctrlKey); experiment.forceUpdate(); }}
				onContextMenu={ e => { experiment.showLeftRailContextMenu({event:e, parent, screen, node:this.node.querySelector('.group-title')}); } }
				>
					<div className="group-title">{id}</div>
					{children.map((child, i) => <ScreenThumbnail screen={child} experiment={experiment} key={`${i}_${child.id}`} parent={children} />)}
					<DropArea parent={children}/>
				</div>
			}
			{!screen.isGroup &&
				<div
					ref={ n => this.node = n }
					className={`draggable screen screen-thumbnail  ${experiment.isSelectedScreen(screen) && 'selected'}`}
					onClick={(e) => { if(experiment.skipClick){return;} e.stopPropagation(); experiment.selectScreen(screen, e.metaKey || e.ctrlKey);  experiment.forceUpdate(); }}
					onContextMenu={ e => { experiment.showLeftRailContextMenu({event:e, parent, screen, node:this.node}); } }
					>
					{id}
				</div>
			}
		</Fragment>
	);}
}

const DropArea = (props) => (
	<div
		className="Screen-hover-area" 
		onMouseOver={e=>{
			window.app.experiment.onScreenDropParams={
				parent:props.parent,
				screen:props.screen,
			};
		}}
		onMouseOut={e=>{
			window.app.experiment.onScreenDropParams={
				parent:null,
				screen:null,
			};
		}}
	><div></div></div>
);



// WEBPACK FOOTER //
// ./src/components/Builder/ExperimentLeftRail.js